<script>
import { hash } from '~/helpers/general'
import { connectQueryRules } from 'instantsearch.js/es/connectors'
import { createWidgetMixin } from 'vue-instantsearch/vue3/es'

export default {
  name: 'AlgoliaCustomDataConnector',
  mixins: [createWidgetMixin({ connector: connectQueryRules })],
  emits: ['custom-data'],
  watch: {
    async 'state.items'(newData, oldData) {
      const hasDataChanged = await this.isDataChanged(newData, oldData)

      if(!hasDataChanged) {
        return
      }

      const data = (newData || []).filter(item => item.image)
      this.$emit("custom-data", data)
    },
  },
  methods: {

    /**
     * Check if data has changed or not.
     * Comparing old and new data hashes.
     * @param {Object} newData - new data.
     * @param {Object} oldData - old data.
     * @returns {Boolean} Returns if data changed or not.
     *
     */
    async isDataChanged(newData, oldData) {
      const newDataHash = await hash(newData)
      const oldDataHash = await hash(oldData)

      return newDataHash !== oldDataHash
    },
  },
  render() {
    return null
  },
}
</script>
